"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Setup/MobileSetup/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Audio = require('web/components/VideoCall/Setup/MobileSetup/Audio'); var _Audio2 = _interopRequireDefault(_Audio);
var _MobileCameraSetup = require('web/screens/VideoCall/segments/MobileCameraSetup'); var _MobileCameraSetup2 = _interopRequireDefault(_MobileCameraSetup);











const MobileSetup = ({
  onCycleCam, isCamCycleAvailable,
  areCamIssuesPresent,
  gotoPreCall,
  goBack,
  onUserProblemPublish,
}) => {
  const [currentStepIdx, setCurrentStepIdx] = _react.useState.call(void 0, 1)
  // Stable, like the class fields: the camera step is a connected (memoized)
  // container.
  const gotoCamSetup = _react.useCallback.call(void 0, () => setCurrentStepIdx(1), [])
  const gotoAudioSetup = _react.useCallback.call(void 0, () => setCurrentStepIdx(2), [])

  const gotoPrevStep = () =>
    currentStepIdx === 1
      ? goBack()
      : gotoCamSetup()

  return (
    _react2.default.createElement('div', { className: "meeting--setup--mobile", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      , _react2.default.createElement('div', { className: "meeting--setup--mobile-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        , _react2.default.createElement('div', {
          onClick: gotoPrevStep,
          className: "meeting--setup--mobile-header--back-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}

          , _react2.default.createElement('img', { src: "/assets/icons/video/back.svg", alt: "<", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
        )
        , _react2.default.createElement('h4', { className: "meeting--setup--mobile-header--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Call Setup" )
        , _react2.default.createElement('span', { className: "meeting--setup--mobile-header--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "Step "
           ,  currentStepIdx , " of 2"
        )
      )
      , _react2.default.createElement('div', { className: "meeting--setup--mobile-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        ,  currentStepIdx === 1 &&
          _react2.default.createElement(_MobileCameraSetup2.default, {
            onCycleCam: onCycleCam,
            isCamCycleAvailable: isCamCycleAvailable,
            areCamIssuesPresent: areCamIssuesPresent,
            gotoNextStep: gotoAudioSetup,
            onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
          )
        
        ,  currentStepIdx === 2 &&
          _react2.default.createElement(_Audio2.default, {
            gotoNextStep: gotoPreCall,
            onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          )
        
      )
    )
  )
}

exports. default = MobileSetup
